import { CLASSES_TYPES } from "redux/reducers/classes/classesTypes";
import { api_get, api_post } from "services/api";
import { startRequest, stopRequest, setSnackbar } from "../search/searchActions";

const {
    GET_CLASSES
} = CLASSES_TYPES

const url = `${process.env.REACT_APP_URL_INTEGRATIONS}/classes`;

const qid = `KZDut9V3GRvS9KeD`;

export const getClasses = () => {
    let getClassesUrl = `${url}?qid=${qid}`;
    return async (dispatch) => {
        dispatch(startRequest())
        await api_get(getClassesUrl).then(resp => {
            dispatch({
                type: GET_CLASSES,
                payload: resp
            })
            dispatch(stopRequest())
        }).catch(err => {
            dispatch(setSnackbar(err))
            dispatch(stopRequest())
        })
    }
}